export default __webpack_public_path__ + "static/media/umuahia-terminal.b1fc12c3.png";